// extracted by mini-css-extract-plugin
export var form = "_d8-0";